<template>
    <div class="row row-xs">
        <div class="col-sm-6 col-lg-3" v-for="card in account.accountCards" :key="card.id">
            <div :class="['card',  'card-body', card.color]">
                <h6 class="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-white tx-semibold mg-b-8">{{ card.name }}</h6>
                <div class="d-flex d-lg-block d-xl-flex align-items-end">
                    <h3 class="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1 tx-white">{{ card.number }}</h3>
                    <!--                    <p class="tx-11 tx-color-03 mg-b-0"><span class="tx-medium tx-white">1.2% <i class="icon ion-md-arrow-up"></i></span></p>-->
                </div>
                <div class="chart-three">
                    <div id="flotChart3" class="flot-chart ht-30"></div>
                </div><!-- chart-three -->
            </div>
        </div><!-- col -->
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    export default {
        //props: ['carditems'],
        name: "Account Card",
        data()  {
            return{
                'cards': [
                    {
                        id: 0,
                        name: 'Total Balance',
                        number: '0.81%',
                        color: 'gray-100'
                    },
                    {
                        id: 1,
                        name: 'Total Debit',
                        number: '3,137',
                        color: 'gray-200'
                    },
                    {
                        id: 2,
                        name: 'Total  Credit',
                        number: 'NGN306.20',
                        color: 'gray-300'
                    },
                    {
                        id: 3,
                        name: 'Number of Accounts',
                        number: '1650',
                        color: 'gray-400'
                    }
                ],
            }
        },
        computed:{
            ...mapState([
                'account'
            ])
        },
        methods: {
            initCard(){
                this.cards[0].number = this.$store.getters['auth/totalBalance']
                this.cards[1].number = this.$store.getters['auth/totalAccount']
            }
        }
    }
</script>

<style scoped>

</style>
